import { FC, JSX } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { StylesConfig } from '@player/content';
import Input from '@semcore/ui/input';

import Arrow2 from '@/shared/ui/icons/Arrow2';

import { ColorSetting } from '../Settings';

interface ILinkButtonProps {}

const LinkButton: FC<ILinkButtonProps> = (): JSX.Element => {
  const formMethods = useFormContext<{ config: StylesConfig }>();
  const { control } = formMethods;

  return (
    <div className="flex flex-col gap-2 rounded-lg bg-black/[.02] py-3 dark:bg-white/[.02]">
      <div className="flex gap-2 pe-4 ps-2">
        <Arrow2 height={28} />
        <ColorSetting
          title="Text color"
          propName="config.link_button.color"
          {...formMethods}
        />
      </div>

      <div className="flex gap-2 pe-4 ps-2">
        <Arrow2 height={28} />
        <ColorSetting
          title="BG color"
          propName="config.link_button.bg_color"
          {...formMethods}
        />
      </div>

      <div className="flex gap-2 pe-4 ps-2">
        <Arrow2 height={28} />
        <div className="flex grow items-center gap-2">
          <Controller
            control={control}
            name="config.link_button.text"
            render={({ field: { value, onChange } }) => (
              <Input size="l" state="normal">
                <Input.Value
                  placeholder="Link title"
                  value={value}
                  onChange={onChange}
                />
              </Input>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default LinkButton;
